import { MOT_TYPE } from '../enums/model.enums';
export class ApiToAppMatcher {
    matchMotToApp(type, category) {
        return MOT_TYPE.ANY;
    }
}
//# sourceMappingURL=apiToAppMatcher.interface.js.map